import { Colors } from "../constants/colors";

export default {
  styleOverrides: {
    root: {
      width: "550px",
      padding: "10px 20px",
      alignItems: "center",
      borderRadius: "4px",
      border: `1px solid ${Colors.GREY225}`,
      background: Colors.WHITE,
      boxShadow: "0px 2px 5px 1px rgba(0, 0, 0, 0.11)",
      "& .MuiAlert-icon": {
        padding: "0px",
        marginRight: "15px",
      },
      "& .MuiAlert-message": {
        width: "100%",
      },
    },
  },
};
